import React from 'react';
import { styles, globalStyles } from './styles';
import { PAGES } from '../data/constants'; // 🌟 引入你的常量文件

export default function GlobalModals({ isGenerating, event, page, hackState, isMobile, choose, modalType, setModalType }) {
  return (
    <>
      {/* 1. 突发事件全屏拦截弹窗 */}
      {/* 🌟 这里把 'GAME' 改成了 PAGES.GAME */}
      {!isGenerating && event.type === 'emergency' && page === PAGES.GAME && !hackState && (
        <div style={styles.modalOverlay}>
          <div className="emergency-modal" style={{ ...styles.eventCard, border: '2px solid #f44336', width: isMobile ? '90%' : '400px', maxWidth: '500px', maxHeight: '85vh', overflowY: 'auto', background: '#110000', boxShadow: '0 0 50px rgba(244, 67, 54, 0.4)' }}>
            <h2 style={{ marginTop: 0, color: '#f44336', textAlign: 'center', fontSize: 24, borderBottom: '1px solid #f44336', paddingBottom: 10 }}>🚨 {event.title}</h2>
            <p style={{ lineHeight: 1.6, color: '#eee', minHeight: 60, fontSize: 16 }}>{event.description}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 25 }}>
              {event.choices.map((c, i) => (
                <button key={i} style={{ ...styles.btnAction, background: 'rgba(244, 67, 54, 0.15)', border: '1px solid #f44336', fontWeight: 'bold' }} onClick={() => choose(c)}>{c.text}</button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* 2. 悬浮菜单引发的交互弹窗 (赞赏/社群) */}
      {modalType && (
        <div style={globalStyles.modalOverlay} onClick={() => setModalType(null)}>
          <div style={globalStyles.modalContent} onClick={e => e.stopPropagation()}>
            <button style={globalStyles.closeBtn} onClick={() => setModalType(null)}>×</button>
            
            {/* --- 赞赏弹窗 --- */}
            {modalType === 'donate' && (
              <>
                <h3 style={{ color: '#4caf50', marginTop: 0 }}>☕ 投喂开发者</h3>
                <p style={{ fontSize: 13, color: '#aaa', lineHeight: 1.5 }}>开发者的 San 值已降至危险水平，感谢你的赛博投喂！</p>
                <div style={globalStyles.qrBox}>
                  <img src={process.env.PUBLIC_URL + "/images/donate-qr.jpg"} alt="赞赏码" style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#fff' }} />
                </div>
              </>
            )}

            {/* --- 社群弹窗 --- */}
            {modalType === 'community' && (
              <>
                <h3 style={{ color: '#2196f3', marginTop: 0 }}>💬 加入赛博职场群</h3>
                <p style={{ fontSize: 13, color: '#aaa', lineHeight: 1.5, marginBottom: 20 }}>来群里吐槽傻逼需求，交流通关攻略！</p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ ...globalStyles.qrBox, width: 140, height: 140, margin: '0 auto' }}>
                      <img src={process.env.PUBLIC_URL + "/images/wechat-qr.jpg"} alt="微信群" style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#fff' }} />
                    </div>
                    <div style={{ fontSize: 12, color: '#4caf50', marginTop: 8, fontWeight: 'bold' }}>微信交流群</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ ...globalStyles.qrBox, width: 140, height: 140, margin: '0 auto' }}>
                      <img src={process.env.PUBLIC_URL + "/images/qq-qr.jpg"} alt="QQ群" style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#fff' }} />
                    </div>
                    <div style={{ fontSize: 12, color: '#2196f3', marginTop: 8, fontWeight: 'bold' }}>QQ 交流群</div>
                  </div>
                </div>
                <p style={{ fontSize: 11, color: '#666', marginTop: 15 }}>* 若二维码失效，请联系开发者更新</p>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}